<template>
  <div>
    <el-form>
      <el-form-item label-width="100px" label="优卡充值金额">
        <el-input v-model="recharge_money" type="number" placeholder="优卡充值金额" style="width: 300px;"></el-input>
        <span style="color: #ed530d;">此处可输入负值，负值表示减优卡余额</span>
      </el-form-item>
      <el-form-item label-width="100px" label="备注">
        <el-autocomplete
          class="inline-input"
          v-model="recharge_message"
          :fetch-suggestions="querySearch"
          placeholder="备注"
          style="width: 300px;"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item class="content-center" style="width: 500px;">
        <el-button type="primary" @click="advanceSubmit()" style="padding: 8px 5px;font-size: 12px;background-color: #7600ff;border-color: #7600ff;">充值</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="ybordersData" :height="wheight-500"  v-loading="loading">
<!--      <el-table-column prop="log_id" label="ID" width="95"></el-table-column>-->
      <el-table-column prop="order_id" label="订单号" width="160"></el-table-column>
      <el-table-column prop="import_money" label="存入金额" width="130"></el-table-column>
      <el-table-column prop="explode_money" label="支出金额" width="130"></el-table-column>
      <el-table-column prop="member_advance" label="当前余额" width="130"></el-table-column>
      <el-table-column prop="message" label="管理备注" width="130"></el-table-column>
      <el-table-column prop="memo" label="业务摘要" width="130"></el-table-column>
      <el-table-column prop="created_date" label="交易时间" width="160"></el-table-column>
    </el-table>
    <div v-if="total_count > pageSize" class="content-padded tc">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :total='total_count' :page-size="pageSize">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {getBenfitAdvanceList, benfitAdvanceChange} from '../../../api/sharer'
import {mapGetters} from "vuex";
export default {
  props: ['userId', 'isLoad'],
  data () {
    return {
      loading: false,
      params: {},
      total_count: 0,
      currentPage: 1,
      pageSize: 20,
      ybordersData: [],
      recharge_money: '',
      recharge_message: '',
      options: [{
        value: '账户停用余额转至'
      }, {
        value: '充值来自停用账号'
      }]
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    handleCurrentChange (val) {
      this.currentPage = val
      this.loading = false
      this.getParams()
      this.getItems(this.params)
    },
    getParams () {
      this.params.page = this.currentPage
      this.params.pageSize = this.pageSize
    },
    getItems (filter) {
      // console.log(filter)
      this.loading = true
      getBenfitAdvanceList(filter).then(response => {
        this.ybordersData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
      })
    },
    advanceSubmit () {
      var recharge_money = this.recharge_money
      var recharge_message = this.recharge_message
      if(!recharge_money || recharge_money == 0){
        this.$message({
          type: 'info',
          message: '请输入正确金额'
        })
        return
      }
      if(!recharge_message){
        this.$message({
          type: 'info',
          message: '请填写备注信息'
        })
        return
      }
      var msg = '此操作将会更改会员优卡余额，是否继续?'
      this.$confirm( msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        let params = {
          'member_id': this.userId,
          'recharge_money': recharge_money,
          'recharge_message': recharge_message
        }
        benfitAdvanceChange(params).then(res => {
          this.$message({ type: 'success', message: '更新成功'})
          this.loading = false
          this.getItems(this.params)
          this.recharge_money = ''
          this.recharge_message = ''
        })
      }).catch(()=> {
        console.log('取消操作')
      })
      this.loading = false
    },
    querySearch(queryString, cb) {
      var restaurants = this.options;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    }
  },
  mounted () {
    // this.params = {page: this.currentPage, pageSize: this.pageSize, user_id: this.userId}
    // this.getItems(this.params)
  },
  watch: {
    userId (newVal, oldVal) {
      if (this.isLoad) {
        this.params = {page: this.currentPage, pageSize: this.pageSize, user_id: newVal}
        this.getItems(this.params)
      }
    },
    isLoad (newVal, oldVal) {
      if (newVal) {
        this.params = {page: this.currentPage, pageSize: this.pageSize, user_id: this.userId}
        this.getItems(this.params)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 10px;
  .frm-tips {
    color: #8d8d8d;
  }
}
</style>



// WEBPACK FOOTER //
// benfitAdvancelist.vue?042ee118